export default {
    list: {
        title: 'Account',
        subtitle: 'Gestisci i soggetti giuridici internazionali',
        newAccount: 'Nuovo Account',
        loading: 'Caricamento accounts...',
        filters: {
            searchPlaceholder: 'Cerca per nome, email, tax ID...',
            statusPlaceholder: 'Filtra per stato',
            entityTypePlaceholder: 'Filtra per tipo',
            countryPlaceholder: 'Filtra per paese',
            userTypePlaceholder: 'Filtra per tipo utente',
            allTypes: 'Tutti i tipi',
            allStatuses: 'Tutti gli stati',
            allCountries: 'Tutti i paesi',
        },
        table: {
            title: 'Accounts',
            description: 'Lista completa dei soggetti giuridici',
            headers: {
                userType: 'User Type',
                legalName: 'Nome Legale',
                entityType: 'Tipo Entità',
                country: 'Paese',
                status: 'Stato',
                createdAt: 'Data Creazione',
                actions: 'Azioni',
            },
            edit: 'Modifica',
            noAccounts: {
                title: 'Nessun account trovato',
                message: 'Prova a modificare i filtri di ricerca',
                emptyMessage: 'Inizia creando il tuo primo account',
                createFirst: 'Crea il primo account',
            },
        },
        status: {
            active: 'Attivo',
            suspended: 'Sospeso',
            inactive: 'Inattivo',
        },
        confirmDelete: 'Sei sicuro di voler eliminare questo account?',
    },
    form: {
        edit: {
            title: 'Modifica Account',
            subtitle: 'Modifica i dettagli del soggetto giuridico',
        },
        create: {
            title: 'Nuovo Account',
            subtitle: 'Crea un nuovo soggetto giuridico',
        },
        loading: 'Caricamento account...',
        back: 'Indietro',
        sections: {
            general: 'Informazioni Generali',
            address: 'Indirizzo',
            contacts: 'Contatti',
            notes: 'Note Aggiuntive',
        },
        stepper: {
            step1: {
                title: 'Informazioni Azienda',
                description: 'Informazioni di base e dettagli legali dell\'azienda',
            },
            step2: {
                title: 'Dettagli Commerciali',
                description: 'Informazioni commerciali e preferenze di trading',
            },
        },
        fields: {
            userType: 'Tipo Utente',
            userTypePlaceholder: 'Seleziona il tipo di utente',
            legalName: 'Nome Legale',
            legalNamePlaceholder: 'Inserisci il nome legale',
            entityType: 'Tipo Entità',
            entityTypePlaceholder: 'Seleziona il tipo di entità',
            taxId: 'Partita IVA / Tax ID',
            taxIdPlaceholder: 'Inserisci la partita IVA o Tax ID',
            status: 'Stato',
            statusPlaceholder: 'Seleziona lo stato',
            street: 'Via',
            streetPlaceholder: 'Inserisci l\'indirizzo completo',
            city: 'Città',
            cityPlaceholder: 'Inserisci la città',
            state: 'Stato/Provincia',
            statePlaceholder: 'Inserisci stato o provincia',
            postalCode: 'CAP',
            postalCodePlaceholder: 'Inserisci il codice postale',
            country: 'Paese',
            countryPlaceholder: 'Seleziona il paese',
            email: 'Email',
            emailPlaceholder: 'nome@azienda.com',
            phone: 'Telefono',
            phonePlaceholder: '+39 123 456 7890',
            notes: 'Note',
            notesPlaceholder: 'Inserisci note aggiuntive sull\'account...',
            // Campi Trade Details
            commodityType: 'Tipo di Commodity',
            commodityTypePlaceholder: 'Seleziona il tipo di commodity',
            commodityTypeOptions: {
                fresh: {
                    label: 'Prodotti Freschi',
                    description: 'Frutta, verdura, ecc.',
                },
                soft: {
                    label: 'Soft Commodities',
                    description: 'Caffè, cacao, zucchero, ecc.',
                },
                hard: {
                    label: 'Hard Commodities',
                    description: 'Metalli, energia, ecc.',
                },
            },
            specificProducts: 'Prodotti Specifici',
            specificProductsPlaceholder: 'Inserisci prodotti specifici (opzionale)',
            mainOrigins: 'Principali Origini/Paesi di Provenienza',
            mainOriginsPlaceholder: 'Seleziona paesi di provenienza',
            mainDestinations: 'Principali Destinazioni/Mercati',
            mainDestinationsPlaceholder: 'Seleziona paesi di destinazione',
            monthlyContainerVolume: 'Volume Mensile Container',
            monthlyContainerVolumePlaceholder: 'Inserisci volume mensile',
        },
        actions: {
            cancel: 'Annulla',
            save: 'Salva Modifiche',
            create: 'Crea Account',
            next: 'Avanti',
            back: 'Indietro',
            previous: 'Precedente',
        },
    },
};

